<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <v-select
                v-model="context.model"
                v-bind="context.attributes"
                :options="options"
                :searchable="false"
                :clearable="true"
                :filterable="true"
                :components="{Deselect}"
                label="label"
                :placeholder="loading ? 'Loading...' : 'Please select...'"
            >
                <!-- Open indicator //-->
                <template #open-indicator="{ attributes }">
                    <span v-bind="attributes">
                        <i class="fas fa-caret-down"></i>
                    </span>
                </template>

                <!-- Select options //-->
                <template slot="option" slot-scope="slotProps">
                    <div class="d-flex flex-row align-items-center">
                        <span class="flex-grow">
                            {{ slotProps.label }}
                        </span>
                        <div
                            v-if="useColours"
                            :style="{
                                backgroundColor: slotProps.value,
                                width: '15px',
                                height:'15px',
                                display: 'inline-block',
                                border: '1px solid #666',
                            }"
                        >
                        </div>
                    </div>
                </template>

                <!-- Selected option -->
                <template slot="selected-option" slot-scope="slotProps">
                    <div class="d-flex flex-row align-items-center">
                        {{ slotProps.label }}
                    </div>
                </template>

                <!-- Loading -->
                <template #spinner="{ loading }">
                    <spinner :show="loading" :size="20" />
                </template>

            </v-select>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Spinner from '@/components/spinner';

export default {
    components: {
        vSelect,
        Spinner,
    },
    props: {
        context: {
            type: Object,
            required: true
        },
        fetchOptions: {
            type: Function,
            default: () => {},
        },
        useColours: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            options: [],
            Deselect: {
                render(createElement) {
                    const vm = this;
                    return createElement('i', {
                        attrs: {
                            class: 'fas fa-times',
                        },
                    }, '');
                },
            },
        }
    },
    async mounted() {
        this.loading = true;
        this.options = await this.fetchOptions();
        this.loading = false;
    },
};
</script>

